import ArchivesVM from './archives-vm';
export default {
  init: function( ele ) {
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    var data = JSON.parse(document.getElementById( 'archive_json' ).value);
    console.log( 'Kadenze.CourseArchives initialization function called' );
    ko.applyBindingsWithValidation( new ArchivesVM( data ), ele, validationOptions );
  }
};
